import styled from "styled-components";


export const VideoTileBettingRangeDefaultBox = styled.div`
    font-size: 1.2rem;
    color: ${({theme}) => theme.colors.brandSecondary.toString()};
    line-height: 1;
    @media ${({theme}) => theme.mediaQuery.xlAndAbove } {
        margin: 12px 0 0 0rem;
        font-size: 1.3rem;
    }
`;
